module.exports = __webpack_public_path__ + "img/tb-logo.aa5dc4f9.svg";